module.exports = "<div class=\"page-inner\">\n\t<div class=\"nav\">\n\t  <button class=\"btn btn-common\" [routerLink]=\"['/feedback']\" routerLinkActive=\"active\" mat-button>\n\t    feedback\n\t  </button>\n\n\t  <button class=\"btn btn-common\" [routerLink]=\"['/question']\" routerLinkActive=\"active\" mat-button>\n\t    question\n\t  </button>\n\t</div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = 1